import { useRecoilState } from 'recoil';

import { indexSearchPageState, indexSearchQueryState } from '@/states/used-cars/index-search.state';


export function useIndexSearch() {
  const [indexPage, setIndexPage] = useRecoilState(indexSearchPageState);
  const [indexQuery, setIndexQuery] = useRecoilState(indexSearchQueryState);

  const clearIndexQuery = () => {
    if (indexQuery && indexQuery.query != '') {
      setIndexQuery({query: ''});
    }
  }
  
  return {
    indexPage,
    setIndexPage,
    indexQuery,
    setIndexQuery,
    clearIndexQuery,
  };
}
